import { Button } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import useNavigation from 'hooks/navigation/useNavigation';
import { t } from 'i18next';
import { ReactNode } from 'react';
import { ClassName } from 'types/ClassName';
import { getUSDCurrency } from 'utils/stringUtils';
import './ExclusiveOfferView.scss';

export const OFFER_STARTING_RATE = 3.99 as const;

export interface IExclusiveOfferViewProps {
  className?: ClassName;
  description: ReactNode;
  onReviewPlans?: () => void;
}

const ExclusiveOfferView = (props: IExclusiveOfferViewProps) => {
  const { className, description, onReviewPlans } = props;

  const navigate = useNavigation('/settings/subscription');

  function handleReviewPlans() {
    onReviewPlans?.();
    navigate();
  }

  const classes = classNames('exclusive-offer-view', className, 'mx-6');

  return (
    <div className={classes}>
      <div className="exclusive-offer-badge">{t('Exclusive Offer')}</div>
      <h2 className="offer-heading">
        {t('Plans Starting at {{price}}', { price: getUSDCurrency(OFFER_STARTING_RATE) })}
      </h2>
      <div className="offer-description">{description}</div>
      <Button className="offer-upgrade-button" type="primary" onClick={handleReviewPlans}>
        {t('Review Plans')}
      </Button>
    </div>
  );
};

export default ExclusiveOfferView;
